(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["app-first-visit-redirect"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  var el = document.querySelector('.app-first-visit-redirect');
  if (!el) return;

  if (el.dataset.designMode === 'true' || (typeof Shopify !== 'undefined' && Shopify.designMode)) {
    return;
  }

  var storageKey = el.dataset.storageKey || 'app_first_visit_discount_seen';
  var discountCode = el.dataset.discountCode || '';
  var firstRedirectPath = el.dataset.firstRedirectPath || '/';
  var repeatRedirectPath = el.dataset.repeatRedirectPath || '/';
  var delayMs = parseInt(el.dataset.delayMs || '0', 10);

  if (!discountCode) {
    console.warn('App redirect: discount code missing');
    return;
  }

  var url = new URL(window.location.href);
  if (url.searchParams.get('reset_app_discount') === '1') {
    localStorage.removeItem(storageKey);
  }

  var discountUrl = '/discount/' + encodeURIComponent(discountCode) + '?redirect=' + encodeURIComponent(firstRedirectPath);

  function go(url) {
    window.location.replace(url);
  }

  function runRedirect() {
    try {
      var alreadySeen = localStorage.getItem(storageKey);

      if (!alreadySeen) {
        localStorage.setItem(storageKey, 'true');
        go(discountUrl);
      } else {
        go(repeatRedirectPath);
      }
    } catch (error) {
      go(discountUrl);
    }
  }

  if (delayMs > 0) {
    window.setTimeout(runRedirect, delayMs);
  } else {
    runRedirect();
  }
});

  } catch(e) { console.error(e); }
})();
})();
